"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _invoiceList = require("@/api/shop/invoiceList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'invoiceTable.vue',
  // 菜品活动 - 推荐购列表
  components: {},
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      tableData: [],
      total: 0,
      listQuery: {
        taxCode: '',
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleEdit: function handleEdit(item) {
      this.$emit('editActivity', item.taxCode);
    },
    addActivity: function addActivity() {
      this.$emit('addActivity');
    },
    handleDelete: function handleDelete(item) {
      var _this = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u4F01\u4E1A \"".concat(item.title, "\" \u5417?"), '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.loading = true;
        (0, _invoiceList.deleteInvoice)(item.id).then(function () {
          _this.$message.success('删除成功');
          _this.search();
        }).catch(function () {
          _this.loading = false;
        });
      }).catch(function () {
        // 用户取消删除
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      this.loading = true;
      (0, _invoiceList.getInvoiceList)(this.listQuery).then(function (res) {
        console.log('发票列表响应:', res);
        _this2.tableData = res.records || [];
        _this2.total = res.total || 0;
        _this2.loading = false;
      }).catch(function (err) {
        console.error('发票列表查询失败:', err);
        _this2.tableData = [];
        _this2.total = 0;
        _this2.loading = false;
      });
    }
  }
};